const { getOffsetTop } = window.BAO.Utils

class TextReveal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    window.setTimeout(() => {
      this.setupCharsMessage()

      this.updateEl()
    }, 500)

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
  }

  setupListeners () {
    super.setupListeners()

    window.addEventListener('scroll', this.onScroll.bind(this), {
      passive: true,
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.revealText()
  }

  setupCharsMessage () {
    let buildContent = ''

    this.els.message.elements.forEach((messageEl) => {
      messageEl.innerText.split('').forEach((char) => {
        buildContent += `<span class="sec-TextReveal_Char" data-text-reveal-el="char">${char}</span>`
      })
    })

    this.els.message.element.innerHTML = buildContent
  }

  revealText () {
    const containerOffsetTop = getOffsetTop(this)
    const elementStartPoint = containerOffsetTop - window.innerHeight / 1.2
    const elementEndPoint = elementStartPoint + window.innerHeight / 2

    if (this.lastKnownY <= elementStartPoint) {
      this.els?.char?.elements.forEach((charEl) => {
        charEl.style.setProperty('--Reveal_Amount', '20%')
      })

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.els?.char?.elements.forEach((charEl) => {
        charEl.style.setProperty('--Reveal_Amount', '100%')
      })

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint
    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount
    const charEls = this.querySelectorAll(this.els.char.selector)

    charEls.forEach((charEl, index) => {
      const minimumPercent = index / charEls.length
      const maximumPercent = (index + 1) / charEls.length
      const isWithinRange =
        scrollYAsAPercentageOfJourney >= minimumPercent &&
        scrollYAsAPercentageOfJourney < maximumPercent

      if (isWithinRange) {
        const charScrolledAmount =
          scrollYAsAPercentageOfJourney - minimumPercent
        const charMaxAmount = maximumPercent - minimumPercent
        const charProgress = charScrolledAmount / charMaxAmount
        const charProgressAmount = Math.round(charProgress * 100 * 10) / 10

        charEl.style.setProperty('--Reveal_Amount', `${charProgressAmount}%`)
      } else if (scrollYAsAPercentageOfJourney > maximumPercent) {
        charEl.style.setProperty('--Reveal_Amount', '100%')
      } else {
        charEl.style.setProperty('--Reveal_Amount', '20%')
      }
    })
  }
}

if (!customElements.get('text-reveal')) {
  customElements.define('text-reveal', TextReveal)
}
